import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { BaseFormComponent } from 'projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component';
import { SelectorService } from 'projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service';
import { Province } from 'projects/sepidz-web-framework/src/lib/models/province.model';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'ngx-province-form',
    templateUrl: './province-form.component.html',
    styleUrls: ['./province-form.component.scss'],
    changeDetection:ChangeDetectionStrategy.OnPush
})
export class ProvinceFormComponent extends BaseFormComponent<Province> {
    constructor(protected selectorService: SelectorService,protected cd: ChangeDetectorRef) {
        super(selectorService,cd);
    }
   async ngOnInit() {
        this.apiName = "Province";
        this.label = this.translate('ClientApp.GNR.Province.Province');
        super.ngOnInit();
    }
    setMaxCode() {
        this.httpCommonService.getMaxCode(this.apiName)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(data => {
                if (!this.model)
                    this.model = <Province>{};
                if (data) {
                    this.model["Code"] = data as number;
                }
                this.setFormGroup(this.model);
            });
    }
    addControl()
    {
        this.cd.markForCheck();
    }
}